import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import ReadyToStartProject from "../components/ReadyToStartProject";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css"; // Importez les styles de AOS
import { Helmet } from "react-helmet";

const GraphicDesignPresentation = () => {
  const [showMore, setShowMore] = useState({});

  useEffect(() => {
    AOS.init({
      duration: 1000, // Durée de l'animation en ms
      easing: "ease-in-out", // Type d'animation
    });
  }, []);

  const toggleShowMore = (index) => {
    setShowMore((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const scrollToElement = (text) => {
    document.getElementById(text).scrollIntoView({ behavior: "smooth" });
  };


  return (
    <div className="bg-gray-900  min-h-screen text-white">
      <Helmet>
        <title>Boostez Votre Image avec le Graphisme</title>
        <meta
          name="description"
          content="Élevez votre image de marque et captez l'attention de votre audience avec des créations graphiques percutantes."
        />
        <meta
          name="keywords"
          content="Graphisme, design, branding, carte de visite, brochure, identité visuelle"
        />
      </Helmet>
      <Navbar />

      {/* Section d'introduction */}
      <section
        data-aos="fade-in" // Ajoutez l'animation AOS ici
        className="h-screen relative bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url('/images/creative.jpg')` }}
      >
        <div className="flex items-center justify-center h-full bg-black bg-opacity-50">
          <div className="text-center text-white max-w-2xl px-6 md:px-12">
            <h1 className="text-5xl font-bold mb-6">
              Boostez Votre Image avec le Graphisme
            </h1>
            <p className="text-2xl mb-6">
              Élevez votre image de marque et captez l'attention de votre
              audience avec des créations graphiques percutantes.
            </p>
            <p className="text-lg mb-8">
              Le graphisme est essentiel pour créer une identité visuelle
              cohérente, attirer l'attention et communiquer efficacement avec
              votre public.
            </p>
            <a
              href="#services"
              className="mt-4 px-6 py-3 bg-purple-500 text-white text-xl font-semibold rounded-md shadow-md hover:bg-purple-600 transition duration-300"
              onClick={() => scrollToElement("services")}
            >
              nos services de graphisme
            </a>
          </div>
        </div>
        <div
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white cursor-pointer animate-bounce"
          onClick={() => scrollToElement("why-graphic-design")}
        >
          <i className="fas fa-chevron-down fa-3x"></i>
        </div>
      </section>

      {/* Section Pourquoi le Graphisme */}
      <section
        data-aos="fade-up"
        id="why-graphic-design"
        className="py-16 px-6 md:px-12 lg:px-24 bg-gray-800"
      >
        <h2 className="text-4xl font-bold mb-8 text-center ">
          Pourquoi le Graphisme ?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Améliorez Votre Branding
            </h3>
            <p className="text-lg mb-4">
              Un bon design graphique renforce votre image de marque et permet à
              votre entreprise de se démarquer.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Créez une Première Impression Impactante
            </h3>
            <p className="text-lg mb-4">
              Les supports visuels, comme les cartes de visite et brochures,
              laissent une impression durable sur vos clients potentiels.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Communiquez Efficacement
            </h3>
            <p className="text-lg mb-4">
              Le graphisme vous aide à communiquer vos idées de manière claire
              et attrayante.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Valorisez Vos Produits et Services
            </h3>
            <p className="text-lg mb-4">
              Un design bien pensé met en valeur vos offres et améliore
              l'expérience utilisateur.
            </p>
          </div>
        </div>
      </section>

      {/* Section des Services de Graphisme */}
      <section
      data-aos="fade-up"
      id="services"
      className="py-16 bg-gray-900 px-6 md:px-12 lg:px-24"
    >
      <h2 className="text-4xl font-bold mb-8 text-center text-yellow-500">
        Nos Services de Graphisme
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

        <div className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Conception de Logos
          </h3>
          <p className="text-lg mb-4">
            Nous créons des logos uniques qui représentent l'identité de votre marque.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[0] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nos designers travaillent avec vous pour comprendre votre vision et créer un logo qui non seulement est esthétique, mais qui incarne aussi les valeurs de votre entreprise.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(0)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[0] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>

        <div className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Cartes de Visite
          </h3>
          <p className="text-lg mb-4">
            Créez des cartes de visite professionnelles qui laissent une impression mémorable.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[1] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nos cartes de visite sont conçues pour capter l'attention et transmettre l'essence de votre entreprise en un coup d'œil, tout en étant élégantes et professionnelles.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(1)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[1] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>

        <div className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Brochures et Flyers
          </h3>
          <p className="text-lg mb-4">
            Développez des brochures et flyers engageants pour promouvoir vos produits ou services.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[2] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nous créons des supports imprimés qui captivent l'attention de votre audience et communiquent efficacement vos messages clés.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(2)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[2] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>

        <div className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Design de Sites Web
          </h3>
          <p className="text-lg mb-4">
            Créez un site web visuellement attrayant et facile à naviguer pour vos visiteurs.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[3] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nos designs sont centrés sur l'utilisateur, assurant une expérience de navigation fluide tout en reflétant l'identité unique de votre marque.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(3)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[3] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>

        <div className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Identité Visuelle
          </h3>
          <p className="text-lg mb-4">
            Développez une identité visuelle cohérente pour votre marque avec nos services de branding.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[4] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nous créons des éléments visuels qui alignent votre marque sur ses valeurs fondamentales, renforçant ainsi sa reconnaissance et sa mémorabilité.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(4)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[4] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>

        <div className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
            Supports Publicitaires
          </h3>
          <p className="text-lg mb-4">
            Créez des affiches, bannières et autres supports publicitaires percutants.
          </p>
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              showMore[5] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <p className="text-lg mb-4">
              Nous concevons des supports publicitaires qui attirent l'attention et communiquent efficacement votre message à votre audience cible.
            </p>
          </div>
          <button
            onClick={() => toggleShowMore(5)}
            className="text-blue-500 hover:text-blue-600 transition duration-300"
          >
            {showMore[5] ? "Lire moins" : "Lire plus"} &rarr;
          </button>
        </div>

      </div>
    </section>

      {/* Section des Tarifs */}
      <section
        data-aos="fade-up"
        id="pricing"
        className="py-20 bg-fixed bg-cover bg-center text-center"
        style={{
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
        }}
      >
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 py-16">
          <h2 className="text-5xl font-bold mb-16 text-yellow-400">
            Nos Tarifs de Graphisme
          </h2>
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
            {/* Plan de Base */}
            <div className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-blue-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col">
              <div className="absolute top-0 left-0 bg-blue-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait de Base
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">€499</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Conception de logo
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Création de carte de visite
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Design d'une brochure simple
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-blue-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-yellow-500 transition duration-300"
              >
                Commencer
              </a>
            </div>

            {/* Plan Avancé */}
            <div className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-yellow-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col">
              <div className="absolute top-0 left-0 bg-yellow-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Le Plus Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Avancé
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">€999</p>
              <ul className="text-left space-y-4 mb-5">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Conception de logo premium
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Pack complet de cartes de visite
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Brochure professionnelle
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Création d'une bannière publicitaire
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-yellow-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-yellow-500 transition duration-300"
              >
                Commencer
              </a>
            </div>

            {/* Plan Pro */}
            <div className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-red-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col">
              <div className="absolute top-0 left-0 bg-red-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Exclusif
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Pro
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">€1499</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Identité visuelle complète
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Création de site web design
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Brochure multi-pages
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Pack complet de supports publicitaires
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-4 px-8 py-3 bg-red-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-yellow-500 transition duration-300 mt-5"
              >
                Commencer
              </a>
            </div>
          </div>
          <p className="mt-10 text-gray-400 text-center">
            Les tarifs indiqués sont standards et peuvent varier en fonction de
            vos besoins spécifiques. N’hésitez pas à nous contacter pour un
            devis personnalisé.
          </p>
        </div>
      </section>

      {/* Section ReadyToStartProject */}
      <ReadyToStartProject />

      {/* Pied de page */}
      <Footer />
    </div>
  );
};

export default GraphicDesignPresentation;
